import React, { ComponentType } from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import {
  ChatScreenWrapper,
  GroupChannelScreenWrapper,
  GroupChannelCreateScreenWrapper
} from './ChatScreens';
import { TNavigationStack } from 'app/types';

type ScreenConfig = { name: keyof TNavigationStack; component: ComponentType<any>; options: object };

const Stack = createNativeStackNavigator<TNavigationStack>();

const CHAT_SCREENS: ScreenConfig[] = [
  { name: 'Chat' , component: ChatScreenWrapper, options: { headerShown: false } },
  { name: 'GroupChannel' , component: GroupChannelScreenWrapper, options: { headerShown: false } },
  { name: 'GroupChannelCreate' , component: GroupChannelCreateScreenWrapper, options: { headerShown: false } },
];

export const CHAT_SCREEN_NAMES: string[] = CHAT_SCREENS.map(s => s.name);

export default function ChatNavigator() {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      {CHAT_SCREENS.map((screen) => (
        <Stack.Screen
          key={screen.name}
          name={screen.name}
          component={screen.component}
          options={screen.options}
        />
      ))}
    </Stack.Navigator>
  );
}
